<template>
<div ref="item">
  <v-card class="card fill-height">
    <v-card-text >
      <v-tooltip :disabled="item.title.length < dispLen" bottom max-width="300">
        <template v-slot:activator="{on, attrs}">
          <div :style="{fontSize: '1.1rem',fontWeight: '600',paddingLeft: '0px', color: getPriorityColor(item.priority)}" v-on="on" v-bind="attrs" color="red">
            {{truncate(item.title)}}
          </div>
          </template>
          <div>
            <p >{{item.title}}</p> 
          </div>
      </v-tooltip>
      <!-- <div style="fontSize: 1.1rem;fontWeight: 600;padding-left: 0px;" >{{item.title}}</div> -->
      <v-tooltip :disabled="item.body.length < dispLen && !item.expanded" bottom max-width="300">
        <template v-slot:activator="{on, attrs}">
          <div style="padding-bottom: 5px" v-bind="attrs"
            v-on="on">{{truncate(item.body)}}</div>
          </template>
          <div>
            <p>{{item.body}}</p> 
            <p>{{item.expanded}}</p> 
          </div>
      </v-tooltip>
      <v-divider />
      <v-row class="msg-row">
        From <v-spacer/> {{item.from}}
      </v-row>
      <v-row class="msg-row">
        Priority <v-spacer/> {{item.priority}}
      </v-row>
      <v-row class="msg-row">
        Sent <v-spacer/> {{dateDisplay(item.cts)}}
      </v-row>
      <v-card-actions >
        <v-row>
          <v-icon class="row-icon" @click="iconClicked('reply',item)">mdi-reply</v-icon>
          <v-icon class="row-icon" @click="iconClicked('replyAll',item)">mdi-reply-all</v-icon>
          <v-icon class="row-icon" @click="iconClicked('forward',item)">mdi-forward</v-icon>
          <!-- <v-icon class="row-icon" @mouseover="hovering"    @mouseleave="hovering">mdi-eye</v-icon> -->
          <v-icon class="row-icon" style='color: brown' @click.stop="iconClicked('remove',item)">mdi-delete</v-icon>
        </v-row>
      </v-card-actions>
    </v-card-text>
  </v-card>
  </div>
</template>
<script>
import moment from 'moment'
import { sync } from "vuex-pathify"
export default {
  props: ['item', 'height', 'extra', 'displayArgs'],
  data: () => ({
    popupElem: false,
    dispLen: 24
  }),
  computed: {
    user: sync('login/loggedinUser'),
    itemHeight () {
      return this.$refs.item.clientHeight
    }
  },
  methods: {
    hovering(val) {
      console.log(val.type)
    },
    dateDisplay(v) {
      return moment(v).format('MM/DD/YYYY hh:mm A')
    },
    truncate(input) {
      if (input.length > this.dispLen) {
        return input.substring(0, this.dispLen) + '...';
      }
      return input;
    },
    getPriorityColor(pri) {
      if (pri == 'high') {
        return 'brown'
      } else if (pri == 'medium') {
        return 'darkGoldenRod'
      } else {
        return 'green'
      }
    },
    iconClicked(op, item) {
      // console.log(op, item)
      this.$emit('update:displayArgs', {op:op, item: item})
    }
  },
  mounted () {
    this.$emit('update:itemHeight', this.itemHeight)
  }
}
</script>
<style 
<style scoped>
.tooltip-inner {
  max-width: 300px !important;
}
.v-tooltip__content {
    background-color: rgba(10, 3, 46, 0.61) !important;
    opacity: 1.0 !important;
}
/* tooltip-background-color	 */
/* rgba(map-get($grey, 'darken-2'), 0.9) !default; */
.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
}
.addbutton {
  margin-left: -5px;
  padding: 5px;
  border: 1px;
  background: green;
  transition: all 0.1s ease-out;
  border-radius: 5px;
  color: white;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
.row-icon {
  padding-right: 12px;
}
.msg-row {
  padding-left: 10px;
  padding-right: 10px;
}
</style>